export default __webpack_public_path__ + "static/media/serviceanytime.6284637d.png";